export const enum StockSecondaryMenuItems {
  PRODUCTS = 'products',
  LIFESTYLES = 'lifestyles',
  MATERIALS = 'materials'
}
